// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"798":"422d8291","878":"047d5f14"}[chunkId] + ".js";
};